export const ApplicationListConst: any[] = [
  {
    name: 'Genomics Workspace',
    icon: 'icon__Pathology-Genomics-Workspace',
    group: 'Genomics'
  },
  {
    name: 'Oncology Pathways',
    icon: 'icon__Oncology-Pathways-Navigator',
    group: 'Oncology Decision Management'
  },
  {
    name: 'Multidisciplinary Team Orchestrator',
    icon: 'icon__Oncology-Tumor-Board-Collaborator-Copy',
    group: 'Oncology Decision Management'
  },
  {
    name: 'Multidisciplinary Team Orchestrator - View',
    icon: 'icon__Oncology-Tumor-Board-Collaborator-Copy',
    group: 'Oncology Decision Management'
  },
  {
    name: 'Pulmonary Nodule Clinic',
    icon: 'icon__Pulmonary-Nodule-Clinic',
    group: 'Oncology Decision Management'
  },
  {
    name: 'Lung Cancer Orchestrator',
    icon: 'icon__Lung-Cancer-Orchestrator',
    group: 'System-Specific Oncology Care'
  },
  {
    name: 'Prostate Cancer Orchestrator',
    icon: 'icon__Prostate-Cancer-Orchestrator-Copy',
    group: 'System-Specific Oncology Care'
  },
  {
    name: 'OncoSIGNal',
    icon: 'OncoSIGNal__icon__Innosign',
    group: 'Genomics'
  },
  {
    name: 'Cardiology Pathways Navigator',
    icon: 'icon__Cardiology-care-orchestrator',
    group: 'Other / Non-Oncology'
  }
];
